import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, SITE_URL } from "@/content/seo";
import { landingContent, pageFaqLD } from "@/content/landing-content";

const TITLE = "Vilamoura Boat Trips · Private Yacht Charters · Morningstar";
const DESC =
  "Private Vilamoura boat trips up to 18 guests — half-day, sunset, Benagil and East Islands. Crewed and catered yacht charters departing from Marina de Vilamoura.";
const PATH = "/vilamoura-boat-trips";
const URL = `${SITE_URL}${PATH}`;
const CONTENT = landingContent.vilamouraBoatTrips;

export const Route = createFileRoute("/vilamoura-boat-trips")({
  component: () => (
    <SitePage
      lang="en"
      heroOverride={{
        eyebrow: "Vilamoura Boat Trips · Private Yacht · Algarve",
        title: "Private Vilamoura boat trips aboard ",
        titleAccent: "Morningstar.",
        sub: "Eight signature cruises from Marina de Vilamoura — half-day cliffs, Benagil Cave, sunset and full-day Algarve charters. Up to 18 guests, fully crewed and catered.",
        ctaPrimary: "Browse boat trips",
        ctaSecondary: "Speak to concierge",
      }}
      pageContent={CONTENT.en}
    />
  ),
  head: () =>
    buildHead({
      lang: "en",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords:
        "Vilamoura boat trips, boat trips Vilamoura, boat tours Vilamoura, boat hire Vilamoura, Vilamoura boat rental, Algarve boat trips",
      altPath: { en: PATH, pt: "/pt/passeios-de-barco-vilamoura" },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Private Yacht Boat Trips from Vilamoura",
              description: DESC,
              url: URL,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Home", path: "/" },
              { name: "Vilamoura Boat Trips", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(pageFaqLD(CONTENT.en.faqs)) },
      ],
    }),
});